import { render, staticRenderFns } from "./FooterNavbarNavLink.vue?vue&type=template&id=4623c666&"
import script from "./FooterNavbarNavLink.vue?vue&type=script&lang=js&"
export * from "./FooterNavbarNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports